module.exports = __webpack_public_path__ + "assets/img/svg/loading/loading-spinner.svg?v=1754999011328";